<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  manage: {
    type: Boolean,
    default: false,
  },
  completed: {
    type: Boolean,
    default: false,
  },
  saving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'delete', 'complete']);
</script>

<template>
  <div class="flex items-center gap-3 border-t border-n-weak pt-5">
    <template v-if="completed">
      <span class="flex-1" />
      <Button label="Close" color="blue" type="button" @click="emit('close')" />
    </template>
    <template v-else-if="manage">
      <Button
        label="Delete task"
        color="ruby"
        variant="ghost"
        type="button"
        :disabled="saving"
        @click="emit('delete')"
      />
      <span class="flex-1" />
      <Button
        label="Mark as done"
        color="teal"
        variant="outline"
        icon="i-lucide-check"
        type="button"
        :disabled="saving"
        @click="emit('complete')"
      />
      <Button
        label="Cancel"
        variant="ghost"
        color="blue"
        type="button"
        @click="emit('close')"
      />
      <Button
        label="Save changes"
        color="blue"
        type="submit"
        :is-loading="saving"
      />
    </template>
    <template v-else>
      <span class="flex-1" />
      <Button
        label="Cancel"
        variant="ghost"
        color="blue"
        type="button"
        @click="emit('close')"
      />
      <Button
        label="Create task"
        color="blue"
        type="submit"
        :is-loading="saving"
      />
    </template>
  </div>
</template>
